import React, { useState, useEffect } from 'react'
import Layout from '../components/Layout'
import api from '../services/api'

const actionConfig = {
  create_contract:  { label: 'สร้างสัญญา',           color: '#3b82f6', bg: '#eff6ff' },
  witness1_sign:    { label: 'ลงนามพยาน 1',           color: '#f59e0b', bg: '#fef9c3' },
  approve_contract: { label: 'ลงนามพยาน 2 & อนุมัติ', color: '#8b5cf6', bg: '#f5f3ff' },
  mayor_sign:       { label: 'นายกลงนาม',             color: '#22c55e', bg: '#f0fdf4' },
  cancel_contract:  { label: 'ยกเลิกสัญญา',           color: '#ef4444', bg: '#fef2f2' },
  delete_contract:  { label: 'ลบสัญญา',               color: '#64748b', bg: '#f1f5f9' },
  send_qr_email:    { label: 'ส่ง QR Email',           color: '#075dcc', bg: '#eff6ff' },
}

const roleConfig = {
  hr:    { label: 'HR',     color: '#3b82f6', bg: '#eff6ff' },
  mayor: { label: 'นายก',   color: '#16a34a', bg: '#f0fdf4' },
  clerk: { label: 'ธุรการ', color: '#8b5cf6', bg: '#f5f3ff' },
  admin: { label: 'Admin',  color: '#ef4444', bg: '#fef2f2' },
}

export default function AdminPage() {
  const [logs, setLogs] = useState([])
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [pagination, setPagination] = useState({})
  const [search, setSearch] = useState('')

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { fetchData() }, [page])

  const fetchData = async () => {
    try {
      setLoading(true)
      const [logsRes, statsRes] = await Promise.all([
        api.get('/admin/logs', { params: { page, limit: 50 } }),
        api.get('/admin/stats')
      ])
      if (logsRes.data.success) { setLogs(logsRes.data.data); setPagination(logsRes.data.pagination) }
      if (statsRes.data.success) setStats(statsRes.data.data)
    } catch (err) { console.error(err) }
    finally { setLoading(false) }
  }

  const handleExport = async () => {
    const res = await api.get('/admin/export/logs', { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const a = document.createElement('a'); a.href = url; a.download = 'logs_export.xlsx'
    document.body.appendChild(a); a.click(); document.body.removeChild(a)
  }

  const filteredLogs = logs.filter(log =>
    !search || log.full_name?.includes(search) || log.username?.includes(search) || log.contract_no?.includes(search) || log.action?.includes(search)
  )

  const statCards = stats ? [
    { label: 'สัญญาทั้งหมด', value: stats.contracts?.total || 0, icon: 'ti-files', color: '#075dcc', bg: '#eff6ff' },
    { label: 'เสร็จสมบูรณ์', value: stats.contracts?.completed || 0, icon: 'ti-circle-check', color: '#22c55e', bg: '#f0fdf4' },
    { label: 'พนักงานทั้งหมด', value: stats.employees?.total || 0, icon: 'ti-users', color: '#8b5cf6', bg: '#f5f3ff' },
    { label: 'ผู้ใช้ระบบ', value: stats.users?.reduce((a, b) => a + parseInt(b.total), 0) || 0, icon: 'ti-user-circle', color: '#f97316', bg: '#fff7ed' },
  ] : []

  return (
    <Layout>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: '24px' }}>
          <h1 style={{ fontSize: '20px', fontWeight: '500', color: '#0f172a' }}>ระบบ Admin</h1>
          <p style={{ fontSize: '13px', color: '#94a3b8', marginTop: '4px' }}>ดูแลระบบและตรวจสอบ Log การใช้งาน</p>
        </div>

        {/* Stats */}
        {stats && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '14px', marginBottom: '24px' }}>
            {statCards.map((s, i) => (
              <div key={i} style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', padding: '18px', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: s.color, borderRadius: '14px 14px 0 0' }} />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '12px' }}>
                  <div style={{ width: '38px', height: '38px', borderRadius: '10px', background: s.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className={`ti ${s.icon}`} style={{ fontSize: '20px', color: s.color }} />
                  </div>
                </div>
                <p style={{ fontSize: '28px', fontWeight: '500', color: '#0f172a' }}>{s.value}</p>
                <p style={{ fontSize: '12px', color: '#94a3b8', marginTop: '2px' }}>{s.label}</p>
              </div>
            ))}
          </div>
        )}

        {/* Log Table */}
        <div style={{ background: 'white', borderRadius: '14px', border: '0.5px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ padding: '16px 20px', borderBottom: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
            <p style={{ fontSize: '14px', fontWeight: '500', color: '#0f172a' }}>Log การใช้งานระบบ</p>
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <button onClick={handleExport}
                style={{ display: 'flex', alignItems: 'center', gap: '6px', padding: '7px 14px', background: '#22c55e', color: 'white', border: 'none', borderRadius: '8px', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }}>
                <i className="ti ti-table-export" style={{ fontSize: '14px' }} />
                Export Log
              </button>
              <div style={{ position: 'relative' }}>
                <i className="ti ti-search" style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', fontSize: '14px', color: '#94a3b8' }} />
                <input type="text" value={search} onChange={e => setSearch(e.target.value)}
                  placeholder="ค้นหาชื่อ, เลขสัญญา..."
                  style={{ padding: '7px 12px 7px 30px', border: '0.5px solid #e2e8f0', borderRadius: '8px', fontSize: '12px', outline: 'none', width: '200px' }} />
              </div>
            </div>
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '60px', color: '#94a3b8', fontSize: '13px' }}>กำลังโหลด...</div>
          ) : (
            <>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr style={{ background: '#f8fafc' }}>
                      {['วันที่/เวลา', 'ผู้ใช้', 'สิทธิ์', 'การกระทำ', 'เลขสัญญา', 'รายละเอียด'].map(h => (
                        <th key={h} style={{ textAlign: 'left', padding: '10px 16px', fontSize: '11px', color: '#94a3b8', fontWeight: '500', whiteSpace: 'nowrap' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {filteredLogs.map(log => {
                      const ac = actionConfig[log.action] || { label: log.action, color: '#64748b', bg: '#f1f5f9' }
                      const rc = roleConfig[log.role] || { label: log.role, color: '#64748b', bg: '#f1f5f9' }
                      return (
                        <tr key={log.id} style={{ borderTop: '0.5px solid #f1f5f9' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                          <td style={{ padding: '10px 16px', fontSize: '11px', color: '#94a3b8', whiteSpace: 'nowrap' }}>
                            {new Date(log.created_at).toLocaleString('th-TH')}
                          </td>
                          <td style={{ padding: '10px 16px', fontSize: '13px', fontWeight: '500', color: '#0f172a' }}>{log.full_name || '-'}</td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: rc.color, background: rc.bg }}>{rc.label}</span>
                          </td>
                          <td style={{ padding: '10px 16px' }}>
                            <span style={{ display: 'inline-flex', padding: '2px 8px', borderRadius: '999px', fontSize: '11px', fontWeight: '500', color: ac.color, background: ac.bg }}>{ac.label}</span>
                          </td>
                          <td style={{ padding: '10px 16px', fontSize: '12px', color: '#64748b' }}>{log.contract_no || '-'}</td>
                          <td style={{ padding: '10px 16px', fontSize: '11px', color: '#94a3b8', maxWidth: '240px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{log.detail || '-'}</td>
                        </tr>
                      )
                    })}
                    {filteredLogs.length === 0 && (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center', padding: '40px', color: '#94a3b8', fontSize: '13px' }}>ไม่พบข้อมูล</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {pagination.totalPages > 1 && (
                <div style={{ padding: '14px 20px', borderTop: '0.5px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <p style={{ fontSize: '12px', color: '#94a3b8' }}>ทั้งหมด {pagination.total} รายการ</p>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
                      style={{ padding: '5px 12px', border: '0.5px solid #e2e8f0', borderRadius: '7px', fontSize: '12px', color: '#64748b', background: 'white', cursor: page === 1 ? 'not-allowed' : 'pointer', opacity: page === 1 ? 0.5 : 1 }}>
                      ← ก่อนหน้า
                    </button>
                    <span style={{ fontSize: '12px', color: '#64748b' }}>{page} / {pagination.totalPages}</span>
                    <button onClick={() => setPage(p => Math.min(pagination.totalPages, p + 1))} disabled={page === pagination.totalPages}
                      style={{ padding: '5px 12px', border: '0.5px solid #e2e8f0', borderRadius: '7px', fontSize: '12px', color: '#64748b', background: 'white', cursor: page === pagination.totalPages ? 'not-allowed' : 'pointer', opacity: page === pagination.totalPages ? 0.5 : 1 }}>
                      ถัดไป →
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Layout>
  )
}
